import React, { Suspense } from 'react';
import ErrorBoundary from '../../jsV2/shared/ErrorBoundary';
import { layoutSize } from '../../jsV2/helpers/globalHelper';

const HelpCenterTitle = React.lazy(() =>
  import(/* webpackChunkName: "TransactionHistoryList.sh.chunk" */ '../panels/HelpCenterTitle'),
);
const TransactionHistoryList = React.lazy(() =>
  import(/* webpackChunkName: "TransactionHistoryList.sh.chunk" */ '../panels/TransactionHistoryList'),
);
const TransactionOtherOptionsContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "TransactionOtherOptionsContainer.sh.chunk" */ '../panels/TransactionOtherOptionsContainer'
  ),
);
const ConversationStatusContainer = React.lazy(() =>
  import(/* webpackChunkName: "ConversationStatusContainer.sh.chunk" */ '../panels/ConversationStatusContainer'),
);

function TransactionLayout() {
  return (
    <div className="sh_home__container" data-testid="sh-home-container">
      {/* Display loader (Spinner) in center while loading */}
      <Suspense fallback={<div className="home-loader-container" />}>
        <ErrorBoundary>
          <HelpCenterTitle size={layoutSize()} />
        </ErrorBoundary>

        <ErrorBoundary>
          <ConversationStatusContainer size={layoutSize()} />
        </ErrorBoundary>

        <ErrorBoundary>
          <TransactionHistoryList size={layoutSize()} />
        </ErrorBoundary>

        <ErrorBoundary>
          <TransactionOtherOptionsContainer size={layoutSize()} />
        </ErrorBoundary>
      </Suspense>
    </div>
  );
}

export default TransactionLayout;
